<div class="banner-title" style="font: var(--font-subheading-2);">
  <div class="go-back" *ngIf="back" style=" margin-right: 8px;">
    <span style="position: absolute;" (click)="goBack.emit(true)">
      <mat-icon matTooltip="Atras">arrow_back</mat-icon>
    </span>
  </div>
  <div class="cortar" style="display:inline-block;font-weight: bold;text-transform: uppercase">{{title}}</div>
</div>